import {
    Component,
    Signal,
    ChangeDetectionStrategy,
    inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ApplicationStateService } from '../../../../modules/application/shared/services/application-state/application-state.service';
import { ApplicationEventActionService } from '../../../../modules/application/shared/services/application-event-action/application-event-action.service';
import { ApplicationExportService } from '../../../../modules/application/shared/services/application-export/application-export.service';
import { openPdfInNewWindow } from '../../../../core/functions/pdf-window-helper';
import { ApplicationState } from '../../../../core/models/application-state/application-state';
import { ApplicationFormControlManagerService } from '../../../../modules/application/shared/services/application-form-control-manager/application-form-control-manager.service';
import { AttachmentManagementService } from '../../../../modules/application/direct-entry/shared/services/attachment-management/attachment-management.service';

@Component({
    selector: 'app-application-actions',
    templateUrl: './application-actions.component.html',
    styleUrl: './application-actions.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, MatIconModule],
})
export class ApplicationActionsComponent {
    private readonly applicationActionService = inject(
        ApplicationEventActionService,
    );
    private readonly applicationStateService = inject(ApplicationStateService);
    private readonly applicationFormControlManagerService = inject(
        ApplicationFormControlManagerService,
    );
    private readonly exportService = inject(ApplicationExportService);
    private readonly attachmentManagementService = inject(
        AttachmentManagementService,
    );

    isApplicationTemplate: Signal<boolean> =
        this.applicationStateService.IsApplicationTemplate;

    constructor() {}

    isReadOnly(): boolean {
        return this.applicationFormControlManagerService.isReadOnly();
    }

    handlePrintClick(): void {
        const applicationState: ApplicationState | null =
            this.applicationStateService.getCurrentApplicationState();

        const appId = applicationState!.applicationId;

        openPdfInNewWindow(this.exportService.getPdf(appId)).subscribe();
    }

    handleProceedToNotesClick(): void {
        this.applicationActionService.triggerProceedToNotesClick();
    }

    handleAttachmentsClick(): void {
        const applicationState =
            this.applicationStateService.getCurrentApplicationState();

        this.attachmentManagementService.displayAttachmentManagementDialog(
            applicationState!.applicationId.toString(),
        );
    }
}
